import * as React from 'react';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import { IReport } from '../../../common/sharedTypes';

interface MergedIndicatorProps {
  reportsMergedToThis?: IReport[];
  supplementedReports?: IReport[];
  pendingMerge?: boolean;
}

function MergedIndicator({ reportsMergedToThis, supplementedReports, pendingMerge }: MergedIndicatorProps) {
  const hasMergedReports = reportsMergedToThis && reportsMergedToThis.length > 0;
  const hasSupplementedReports = supplementedReports && supplementedReports.length > 0;  
  return (
    <>{' '}
      {(hasMergedReports || hasSupplementedReports || pendingMerge) &&
        <OverlayTrigger
          placement="top"
          overlay={
            <Tooltip
              id='tooltip-merged-indicator-top'
            >
              {pendingMerge ? 'Pending Merge to Driver Report' 
              : hasMergedReports 
                ? 'Merged' 
                : 'Supplemented'}
            </Tooltip>
          }
        >
          {hasMergedReports || pendingMerge ?
            <i className="fas fa-object-group" />
            :
            <i className="far fa-object-group" />
          }
        </OverlayTrigger>
      }
    </>
  )
}

export default MergedIndicator;